export const addReportFunction = async (data, thunkApi) => {
  try {
    const { reports } = thunkApi.extra.apiService;

    const response = await reports.post("/", {
      name: data?.title,
      category: data?.category?.join(","),
      subcategory: data?.subcategory?.join(","),
      brand: data?.brand?.join(","),
      location: data?.location?.join(","),
      canprod_ids: data?.canprod_ids || undefined,
    });

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getReportFunction = async (data, thunkApi) => {
  try {
    const { reports } = thunkApi.extra.apiService;

    const response = await reports.get("/");

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateReportFunction = async (data, thunkApi) => {
  try {
    const { reports } = thunkApi.extra.apiService;

    const response = await reports.put("/" + data?.id, {
      name: data?.title,
      category: data?.category?.join(","),
      subcategory: data?.subcategory?.join(","),
      brand: data?.brand?.join(","),
      location: data?.location?.join(","),
      canprod_ids: data?.canprod_ids !== undefined ? data.canprod_ids : undefined,
    });

    return { data: response.data, index: data?.index };
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteReportFunction = async (data, thunkApi) => {
  try {
    const { reports } = thunkApi.extra.apiService;

    const response = await reports.delete("/" + data?.id);

    return { index: data?.index };
  } catch (error) {
    return Promise.reject(error);
  }
};
